import { isQA } from "@src/constants/constants";
import ReactGA from "react-ga4";

const disableGoogleAnalytics = isQA;
const googleAnalyticsToken = process.env.GOOGLE_ANALYTICS_ID;

if (googleAnalyticsToken && !disableGoogleAnalytics) {
	ReactGA.initialize(googleAnalyticsToken);
} else {
	console.log("%cGoogle Analytics, not available", "background-color:#44e088;color:black;border-radius:8px;padding: 2px 10px");
}
